import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../utils/axiosBaseQuery';
import { ApartmentDetails } from '../../types/bookingCreation';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';

interface ApartmentByCityListProps {
  city: string;
  fromDate: string;
  toDate: string;
  numberOfGuests: number;
  orderId?: string | null;
  useCase?: string;
}

export const apartmentBookingApiSlice = createApi({
    reducerPath: 'apartmentBookingApiSlice',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: axiosBaseQuery(),
    tagTypes: ['apartmentByCityList', 'apartmentDetails'],
    endpoints: (builder) => ({
        getApartmentByCityList: builder.query({
            query: (data: ApartmentByCityListProps) => {
                let url = `/apartments/city/${data.city}/availabilities/${data.fromDate}/${data.toDate}?guests=${data.numberOfGuests}`;
                
                if (data.orderId) {
                    url += `&orderId=${data.orderId}`;
                }
                
                if (data.useCase) {
                    url += `&use_case=${data.useCase}`;
                }
                
                return {
                    url,
                };
            },
            providesTags: ['apartmentByCityList'],
        }),
        getApartmentDetails: builder.query<
            ApartmentDetails,
            { apartmentId: string }
        >({
            query: ({ apartmentId }) => {
                return {
                    url: `/apartments/${apartmentId}/details`,
                };
            },
            providesTags: ['apartmentDetails'],
        }),
    }),
});

export const { useGetApartmentByCityListQuery, useGetApartmentDetailsQuery } =
  apartmentBookingApiSlice;
